module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-card', {
    staticClass: "mytable"
  }, [(_vm.search) ? _c('f7-list', {
    staticClass: "search",
    attrs: {
      "form": ""
    }
  }, [_c('f7-list-item', [_c('f7-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.searchPlaceHolder
    },
    model: {
      value: (_vm.q),
      callback: function($$v) {
        _vm.q = $$v
      },
      expression: "q"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _vm._t("default", [_c('f7-table', {
    staticStyle: {
      "margin-bottom": "70px"
    }
  }, [_c('f7-table-row', {
    attrs: {
      "heading": ""
    }
  }, [_c('f7-table-cell', [_vm._v("#")]), _vm._v(" "), _vm._l((_vm.columns), function(column) {
    return (column.showInList !== false || column.title === true) ? _c('f7-table-cell', {
      key: column.name,
      class: column.thClass ? column.thClass : ''
    }, [_vm._v("\n                    " + _vm._s(column.label) + "\n                ")]) : _vm._e()
  }), _vm._v(" "), (_vm.actions && _vm.actions.length > 0) ? _c('f7-table-cell') : _vm._e()], 2), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('f7-table-row', {
      key: item.id
    }, [_c('f7-table-cell', [_vm._v(_vm._s(_vm.items.indexOf(item) + 1))]), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return (column.showInList !== false || column.title === true) ? _c('f7-table-cell', {
        key: column.name,
        class: (column.tdClass ? column.tdClass : '') + ' ' + (column.title === true ? 'text-right' : '')
      }, [_vm._v("\n                    " + _vm._s(_vm.getFieldValue(item, column)) + "\n                ")]) : _vm._e()
    }), _vm._v(" "), (_vm.actions && _vm.actions.length > 0) ? _c('f7-table-cell', _vm._l((_vm.actions), function(action) {
      return _c('f7-link', {
        key: action.name,
        staticClass: "button",
        domProps: {
          "innerHTML": _vm._s(action.render ? action.render(item) : (action.label ? action.label : _vm.$root.__(action.name)))
        },
        on: {
          "click": function($event) {
            _vm.itemClick(item, action)
          }
        }
      })
    })) : _vm._e()], 2)
  })], 2)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33228284"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VTable.vue
// module id = 134
// module chunks = 1